import { render } from "./WB.vue?vue&type=template&id=426c57b3"
import script from "./WB.vue?vue&type=script&lang=js"
export * from "./WB.vue?vue&type=script&lang=js"

import "./WB.vue?vue&type=style&index=0&id=426c57b3&lang=css"
script.render = render

export default script